import { motion } from "framer-motion";
import { SERVICES } from "@/lib/site-data";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section data-testid="services-section" id="services" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Our Services</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            Complete precious metal <span className="gold-gradient-text font-medium">solutions</span>.
          </h2>
          <p className="mt-5 text-[#4B5563] text-base lg:text-lg leading-relaxed">
            From scrap intake to certified bullion — a single, transparent refining workflow built for India's
            most demanding jewellers, traders and institutions.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Gem;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                data-testid={`service-card-${i}`}
                className="group relative p-7 lg:p-8 bg-[#F4F9FC] border border-[#E5E5E5] rounded-lg lift-card"
              >
                <div className="w-12 h-12 rounded-md flex items-center justify-center bg-white border border-[#E5E5E5] group-hover:border-[#D4AF37] transition-colors">
                  <Icon className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading mt-5 text-xl font-medium text-[#0A0A0A]">{s.title}</h3>
                <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{s.desc}</p>
                <div className="mt-6 flex items-center text-xs uppercase tracking-[0.18em] text-[#0A0A0A] group-hover:text-[#D4AF37] transition-colors">
                  Learn more <ArrowUpRight className="w-3.5 h-3.5 ml-1.5" strokeWidth={1.6} />
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
